import { render } from "./HonorsSection.vue?vue&type=template&id=b0751554&scoped=true"
import script from "./HonorsSection.vue?vue&type=script&lang=js"
export * from "./HonorsSection.vue?vue&type=script&lang=js"

import "./HonorsSection.vue?vue&type=style&index=0&id=b0751554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0751554"]])

export default __exports__